import { QueryKeys } from '@/enums';
import { IColumnBannerProperty, IGlobalAdPopUp, IHomepageSections, IHomepageStructure } from '@/interfaces/homepage';
import { getColumnBanners, getGlobalAdPopUp, getHomepageSections, getHomepageStructure, getMegaMenu } from '@/services/product.service';
import { useQuery } from '@tanstack/react-query';
import { getProductsCarousel } from '@/helpers/homepage-helper';
import { getAnnouncementBarItemPopup } from '@/services/announcementbar-popup.service';

export const useHomepageStructure = () => {
  return useQuery<IHomepageStructure>({
    queryKey: [QueryKeys.homepageStructure],
    queryFn: async () => {
      const homepageStructure = await getHomepageStructure();
      return homepageStructure;
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useMegaMenu = () => {
  return useQuery<IMegaMenu>({
    queryKey: [QueryKeys.megaMenu],
    queryFn: async () => {
      let res = await getMegaMenu();
      let returnVal = res;
      returnVal?.Items?.forEach((element, returnValIndex) => {
        element?.Items?.forEach((item, index) => {
          element.Brands = [];
          if (item.Name.toLowerCase() == 'brands' && item.ItemType == 'Text' && !item.SeName) {
            element.Brands.push({ ...item });
            element.Items.splice(index, 1);
          }
        });
      });
      return returnVal;
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useHomepageSections = (layoutId = '', Hash = '') => {
  const queryKey = layoutId ? [QueryKeys.homepageSectionsPreview, layoutId, Hash] : [QueryKeys.homepageSections];

  return useQuery<IHomepageSections>({
    queryKey,
    queryFn: async () => {
      const homepageSections = await getHomepageSections(layoutId, Hash);
      if (homepageSections.ProductCarousel) {
        const carouselProducts = await getProductsCarousel(homepageSections.ProductCarousel.Id, homepageSections.ProductCarousel.CarouselType);
        homepageSections.ProductCarousel.products = carouselProducts.PageData;
      }
      if (homepageSections.ProductCarousel2) {
        const carouselProducts = await getProductsCarousel(homepageSections.ProductCarousel2.Id, homepageSections.ProductCarousel2.CarouselType);
        homepageSections.ProductCarousel2.products = carouselProducts.PageData;
      }
      return homepageSections;
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useGlobalAdPopUp = () => {
  return useQuery<IGlobalAdPopUp>({
    queryKey: [QueryKeys.adPopUp],
    queryFn: async () => {
      const globalAdPopUp = await getGlobalAdPopUp();
      return globalAdPopUp;
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useAnnouncementBarPopup = (announcementBarId: string, itemId: string) => {
  return useQuery({
    queryKey: [QueryKeys.announcementBarPopup, announcementBarId, itemId],
    queryFn: async () => await getAnnouncementBarItemPopup({ announcementBarId, itemId }),
    enabled: Boolean(announcementBarId && itemId),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useColumnBanners = () => {
  return useQuery<IColumnBannerProperty[]>({
    queryKey: [QueryKeys.columnBanners],
    queryFn: async () => {
      const tempColumnBanners = await getColumnBanners();
      return tempColumnBanners;
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
